import { BrowserRouter, Route, Routes, useLocation, Navigate, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Home from './Files/Home';
import Copuontable from "./pages/Copuon/Copuontable";
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import { isMobile, isTablet } from "react-device-detect";
import './App.css';
import './App_2.css';
import './Table.css';
import Staffcreate from './pages/Staff/Staffcreate';
import Stafftable from './pages/Staff/Stafftable';
import Staffedit from './pages/Staff/Staffedit';
import Examresult from './pages/Examresult';
import Examdata from './pages/Examdata';
import Coustomertable from './pages/Coustomer/Coustomertable';
import Useredit from './pages/Coustomer/Useredit';
import Sortdateresult from './pages/Resultdata/Sortdateresult';
import Pdftest1 from './Pagesmaker/Pdftest1';
import Login from './pages/Login';
import Razorpay from './Pagesmaker/Razorpay';
import Paymenttable from './pages/Paymentoverview/Paymenttable';
import UserAdd from './pages/Coustomer/UserAdd';
import Pagetestfordashboard from './Pagesmaker/Pagetestfordashboard';
import Downloadresult from './Files/Subjects/Downloadresult';
import AddCoupon from './pages/Copuon/AddCoupon';
import EditCoupon from './pages/Copuon/Editcp';
import Exam from './Files/Subjects/Exam';
import Wealth from './Files/Subjects/Wealth';
import Workeducation from './Files/Subjects/Workeducation';
import Health from './Files/Subjects/Health';
import SelfAww from './Files/Subjects/SelfAww';
import Payment from './Files/Payment';
import Result from './Files/Result';
import Totorialstartpage from './Files/Totorialstartpage';
import LOgionnew from './LOgionnew';
import Loginforgot from './Pagesmaker/Loginforgot';
import Coustomerdashboard from './Pagesmaker/Coustomerdashboard';
import Thankyou from './Files/Thankyou';
import Redirect from './Files/Redirect';
import Pdf from './Files/Subjects/Pdf';
import Pdfone from './Files/Subjects/Pdfone';
import Loaders from './Files/Loaders';
import Pagetestwr from './Pagesmaker/Pagetestwr';
import Responsive from './pages/Responsive';
import PrivacyPolicy from './Pagesmaker/PrivacyPolicy';
import Termsconditions from './Pagesmaker/Termsconditions';
import RefundPolicy from './Pagesmaker/RefundPolicy';
import RedirectModal from './components/RedirectModal';
import Tempexporter from './pages/Tempexporter';
import TestAnswerexporter from './pages/TestAnswerexporter';
import ExamGuard from './components/ExamGuard';

// Session timeout duration (30 minutes)
const SESSION_TIMEOUT = 30 * 60 * 1000;

function AppContent() {
  const location = useLocation();
  const [staffToken, setStaffToken] = useState(localStorage.getItem("staffToken"));
  const [lastActivity, setLastActivity] = useState(Date.now());
  const [sessionExpired, setSessionExpired] = useState(false);
  const [responsive, setResponsive] = useState(false);
const navigate = useNavigate();
  // Check device type
  useEffect(() => {
    if (isMobile || isTablet) {
      setResponsive(true);
    }
  }, []);

  // Clear sensitive data when on home page
  // useEffect(() => {
  //   if (location.pathname === "/") {
  //     ['staffDatafororles', 'staffToken', 'staffData', 'token', 'user'].forEach(item => {
  //       localStorage.removeItem(item);
  //     });
  //     setStaffToken(null);
  //   }
  // }, [location.pathname]);

// useEffect(() => {
//   if (location.pathname !== "/") return;

//   const staffToken = localStorage.getItem("staffToken");
//   const userToken = localStorage.getItem("token");

//   const isTokenValid = (token) => {
//     try {
//       const payload = JSON.parse(atob(token.split(".")[1]));
//       console.log(payload.exp * 1000 );
//       return payload.exp * 1000 > Date.now();
//     } catch {
//       return false;
//     }
//   };

//   // Staff
//   if (staffToken && isTokenValid(staffToken)) {
//     ["token", "user"].forEach((item) => localStorage.removeItem(item));
//     navigate("/customertable/1", { replace: true });
//     return;
//   }

//   // User
//   if (userToken && isTokenValid(userToken)) {
//     ["staffDatafororles", "staffToken", "staffData"].forEach(
//       (item) => localStorage.removeItem(item)
//     );
//     navigate("/CustomerDashboard", { replace: true });
//     return;
//   }

//   // Invalid / no token → cleanup only on "/"
//   ["staffDatafororles", "staffToken", "staffData", "token", "user"].forEach(
//     (item) => localStorage.removeItem(item)
//   );

//   setStaffToken(null);
// }, [location.pathname, navigate]);
// const [authMessage, setAuthMessage] = useState("");

// useEffect(() => {
//     const authPages = ["/", "/Loginuser","/Login",]; // 👈 pages where this should run

//   if (!authPages.includes(location.pathname)) {
//     setAuthMessage("");
//     return;
//   }
//   const staffToken = localStorage.getItem("staffToken");
//   const userToken = localStorage.getItem("token");

//   const isTokenValid = (token) => {
//     try {
//       const payload = JSON.parse(atob(token.split(".")[1]));
//       return payload.exp * 1000 > Date.now();
//     } catch {
//       return false;
//     }
//   };

//   let redirectPath = "";
//   let message = "";

//   if (staffToken && isTokenValid(staffToken)) {
//     ["token", "user"].forEach(item => localStorage.removeItem(item));
//     redirectPath = "/customertable/1";
//     message = "You have an active staff session. Redirecting in 5 seconds…";
//   }

//   if (!redirectPath && userToken && isTokenValid(userToken)) {
//     ["staffDatafororles", "staffToken", "staffData"].forEach(
//       item => localStorage.removeItem(item)
//     );
//     redirectPath = "/CustomerDashboard";
//     message = "You have an active user session. Redirecting in 5 seconds…";
//   }

//   if (!redirectPath) {
//     setAuthMessage("");
//     return;
//   }

//   setAuthMessage(message);

//   const timeout = setTimeout(() => {
//     setAuthMessage("");                 // 👈 THIS WAS MISSING
//     navigate(redirectPath, { replace: true });
//   }, 5000);

//   return () => clearTimeout(timeout);

// }, [location.pathname, navigate]);
  const [authMessage, setAuthMessage] = useState("");

useEffect(() => {
    const authPages = ["/", "/Loginuser", "/Login"];

    if (!authPages.includes(location.pathname)) {
      setAuthMessage("");
      return;
    }

    const isTokenValid = (token) => {
      if (!token || typeof token !== "string") return false;

      const parts = token.split(".");
      if (parts.length !== 3) return false;

      try {
        const payload = JSON.parse(atob(parts[1]));
        if (!payload?.exp) return false;

        return payload.exp * 1000 > Date.now();
      } catch {
        return false;
      }
    };

    const getValidToken = (key) => {
      const token = localStorage.getItem(key);

      if (!token || !isTokenValid(token)) {
        localStorage.removeItem(key);
        return null;
      }

      return token;
    };

    const staffToken = getValidToken("staffToken");
    const userToken = getValidToken("token");

    let redirectPath = "";
    let message = "";

    if (staffToken) {
      ["token", "user"].forEach((item) => localStorage.removeItem(item));

      redirectPath = "/customertable/1";
      message = "You have an active staff session. Redirecting in 5 seconds…";
    }

    if (!redirectPath && userToken) {
      ["staffDatafororles", "staffToken", "staffData"].forEach((item) =>
        localStorage.removeItem(item)
      );

      redirectPath = "/CustomerDashboard";
      message = "You have an active user session. Redirecting in 5 seconds…";
    }

    if (!redirectPath) {
      setAuthMessage("");
      return;
    }

    setAuthMessage(message);

    const timeout = setTimeout(() => {
      setAuthMessage("");
      navigate(redirectPath, { replace: true });
    }, 5000);

    return () => clearTimeout(timeout);
  }, [location.pathname, navigate]);



  // Track user activity for session timeout
  useEffect(() => {
    const activities = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

    const updateLastActivity = () => {
      setLastActivity(Date.now());
      if (sessionExpired) {
        setSessionExpired(false);
      }
    };

    activities.forEach(event => {
      window.addEventListener(event, updateLastActivity);
    });

    const checkSession = setInterval(() => {
      if (Date.now() - lastActivity > SESSION_TIMEOUT && staffToken) {
        setSessionExpired(true);
        // Clear tokens and redirect
        localStorage.removeItem("staffToken");
        setStaffToken(null);
      }
    }, 1000); // Check every second

    return () => {
      activities.forEach(event => {
        window.removeEventListener(event, updateLastActivity);
      });
      clearInterval(checkSession);
    };
  }, [lastActivity, staffToken, sessionExpired]);

  // Paths that shouldn't show the layout (sidebar/navbar)
  const excludedPaths = [
    "/",
    "/Exam",
    "/wealth",
    "/we",
    "/health",
    "/Selfawareness",
    "/Payment",
    "/Loaders",
    "/Result",
    "/TutorialPage",
    "/Loginuser",
    "/Loginforgot",
    "/CustomerDashboard",
    "/Thankyou",
    "/redirectpage",
    "/Login",
    "/Pdf/:id",
    "/privacy-policy",
    "/terms-conditions",
    "/Pagetestwr/:id",
    "/Pdfone/:id",
    "/Pdftest1/:id",
    "/Downloadresult/:userId/:examId",
    "/Cancellation/Refund Policy"
    
  ];

  // Paths that should show the admin layout
  const adminPaths = [
    "/Copuontable/:pointindex",
    "/stafftable",
    "/s2/:pointindex",
    "/Staffedit/:id/:pointindex",
    "/exam/:pointindex",
    "/Examresult/:id/:pointindex",
    "/customertable/:pointindex",
    "/Useredit/:id/:pointindex",
    "/Sortdateresult",
    "/Razorpay",
    "/Paymenttable/:pointindex",
    "/UserAdd",
    "/Pagetestfordashboard",
    "/AddCoupon",
    "/EditCoupon/:id/:pointindex",
        "/tempday",
        '/TestAnswerexporter'

  ];

  // Check if current path is excluded
  const isExcluded = excludedPaths.some(path => {
    const regex = new RegExp(`^${path.replace(/:[^\s/]+/g, '([^/]+)')}$`, "i");
    return regex.test(location.pathname);
  });

  // Check if current path is an admin path
  const isAdminPath = adminPaths.some(route => {
    const routeRegex = new RegExp(`^${route.replace(/:[^\s/]+/g, '([^/]+)')}$`);
    return routeRegex.test(location.pathname);
  });

  const renderContent = () => {
    if (sessionExpired) {
      return <Navigate to="/" replace />;
    }

    if (staffToken) {
      if (isAdminPath) {
        return (
          <>
            <Sidebar>
            {/* <div className="containerNormal mainContainerlarge"> */}
              {/* <Navbar /> */}
              {/* <div className="contain-body"> */}
                {/* <div className="containerInside"> */}
                  {/* <div className="container-inside-body"> */}
                    <Routes>
                      <Route path="/Copuontable/:pointindex" element={<Copuontable />} />
                      <Route path="/stafftable" element={<Staffcreate />} />
                      <Route path="/s2/:pointindex" element={<Stafftable />} />
                      <Route path="/Staffedit/:id/:pointindex" element={<Staffedit />} />
                      <Route path="/exam/:pointindex" element={<Examdata />} />
                      <Route path="/Examresult/:id/:pointindex" element={<Examresult />} />
                      <Route path="/customertable/:pointindex" element={<Coustomertable />} />
                      <Route path="/Useredit/:id/:pointindex" element={<Useredit />} />
                      <Route path="/Sortdateresult" element={<Sortdateresult />} />
                      <Route path="/Razorpay" element={<Razorpay />} />
                      <Route path="/Paymenttable/:pointindex" element={<Paymenttable />} />
                      <Route path="/UserAdd" element={<UserAdd />} />
                      <Route path="/Pagetestfordashboard" element={<Pagetestfordashboard />} />
                      <Route path="/AddCoupon" element={<AddCoupon />} />
                      <Route path="/EditCoupon/:id/:pointindex" element={<EditCoupon />} />
                   <Route path="/tempday" element={<Tempexporter />} />
             <Route path="/TestAnswerexporter" element={<TestAnswerexporter />} />

{/* ExcelExporter */}
                      {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
                    </Routes>
                  {/* </div> */}
                {/* </div> */}
              {/* </div> */}
            {/* </div> */}
               </Sidebar>
          </>
        );
      }
      // return <Navigate to="/customertable/1" replace />;
      return
    }

    return (

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Exam" element={<Exam />} />
        <Route path="/wealth"  element={
    <ExamGuard>
      <Wealth />
    </ExamGuard>
  } />
        <Route path="/we" element={ <ExamGuard><Workeducation /></ExamGuard>} />
        <Route path="/health" element={<ExamGuard><Health/></ExamGuard>} />
        <Route path="/Selfawareness" element={<ExamGuard><SelfAww /></ExamGuard> } />
        <Route path="/Payment" element={<Payment />} />
        <Route path="/Loaders" element={<Loaders />} />
        <Route path="/Result" element={<Result />} />
        <Route path="/TutorialPage" element={<Totorialstartpage />} />
        <Route path="/Loginuser" element={<LOgionnew />} />
        <Route path="/Loginforgot" element={<Loginforgot />} />
        <Route path="/CustomerDashboard" element={<Coustomerdashboard />} />
        <Route path="/Thankyou" element={<Thankyou />} />
        <Route path="/redirectpage" element={<Redirect />} />
        <Route path="/Pdf/:id" element={<Pdf />} />
        <Route path="/Pagetestwr/:id" element={<Pagetestwr />} />
        <Route path="/Pdfone/:id" element={<Pdfone />} />
        <Route path="/Pdftest1/:id" element={<Pdftest1 />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<Termsconditions />} />
        <Route path="/terms-conditions" element={<Termsconditions />} />
        <Route path="/Cancellation/Refund Policy" element={<RefundPolicy />} />
        {/* /Cancellation/Refund Policy */}
        <Route path="/Downloadresult/:userId/:examId" element={<Downloadresult />} />
        <Route path="/Login" element={<Login setStaffToken={setStaffToken} />} />
      </Routes>
    );
  };

  return (
    <div className={`app-container ${responsive ? 'mobile' : ''}`}>
       <RedirectModal message={authMessage} />
      {renderContent()}
    </div>
  );
}

function App() {
  const [responsive, setResponsive] = useState(false);

  // Check device type
  useEffect(() => {
    if (isMobile || isTablet) {
      setResponsive(true);
    }
  }, []);
  return (
    <BrowserRouter>
      {responsive == false ? <AppContent />
        : <Routes>
          <Route path="*" element={<Responsive />} />
          <Route path="/" element={<Home />} />
          {/* <Route path="/" element={<Responsive />} /> */}

        </Routes>}
    </BrowserRouter>
  );
}

export default App;